import script from "./PublishingArticle.vue?vue&type=script&setup=true&lang=js"
export * from "./PublishingArticle.vue?vue&type=script&setup=true&lang=js"

import "./PublishingArticle.vue?vue&type=style&index=0&id=61a829af&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61a829af"]])

export default __exports__